var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('period-filter'),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.eventFilter}},[_vm._v("Filtrar")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }